'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref, _ref2) {
  var shadow = _ref.shadow,
      background = _ref.background,
      foreground = _ref.foreground,
      outerColor = _ref.outerColor,
      width = _ref.width,
      spacing = _ref.spacing,
      fullHeight = _ref.fullHeight,
      styles = _ref.styles;
  var calculateSpacing = _ref2.calculateSpacing,
      colors = _ref2.colors,
      rhythm = _ref2.rhythm,
      shadows = _ref2.shadows,
      treatments = _ref2.treatments;

  var defaultStyles = {
    root: _extends({
      maxWidth: width ? rhythm(width) : treatments.container.maxWidth,
      minHeight: fullHeight && '100vh',
      margin: '0 auto'
    }, calculateSpacing(spacing), {
      backgroundColor: background && colors[background],
      color: foreground && colors[foreground]
    }, treatments.body, {
      boxShadow: shadow && shadows[shadow]
    }),

    outer: {
      backgroundColor: outerColor && colors[outerColor]
    }
  };

  return (0, _merge2.default)(defaultStyles, styles);
};


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/container/styles.js
// module id = 882
// module chunks = 0